import { useState } from 'react';

import { Switch } from 'antd';

import { FormGroup } from '@/components/FormGroup';
import PreviewProduct from '@/components/wizard/PreviewProduct';
import useProductStore, { type PaymentType } from '@/stores/productStore';

import Blululup from './Blululup';

const bgStyle = {
  background: '#f3f3f3',
  backgroundImage: 'radial-gradient(#e1e1e1 2px, transparent 0)',
  backgroundSize: '18px 18px',
  backgroundPosition: '-8px -8px center'
};

export default function BlululupContainer() {
  const [collapsable, setCollapsable] = useState(true);
  const [validationState, setValidationState] = useState(true);
  const [reviewMode, setReviewMode] = useState(false);

  const product = useProductStore(d => d);

  const setPaymentType = (type: PaymentType) => {
    product.setFields({
      payment: {
        ...product.payment,
        type: type as any
      }
    });
  };

  return (
    <>
      <div className='bg-surface-default m-2 flex flex-row gap-4 p-2'>
        <div className='rounded-default flex flex-row gap-4 bg-orange-300 p-2'>
          <div>
            <Switch id='toggle-collapsable' checked={collapsable} onChange={v => setCollapsable(v)} />{' '}
            <span>Collapsable</span>
          </div>
          <div>
            <Switch id='toggle-validation-state' checked={validationState} onChange={v => setValidationState(v)} />{' '}
            <span>Validation State</span>
          </div>
          <div>
            <Switch id='toggle-preview-mode' checked={reviewMode} onChange={v => setReviewMode(v)} />{' '}
            <span>Preview Mode</span>
          </div>
        </div>
        <div className='rounded-default flex flex-row gap-4 bg-blue-400 p-2'>
          <div>
            <Switch
              id='toggle-payment-one_time'
              checked={product.payment.type === 'oneTime'}
              onChange={() => setPaymentType('oneTime')}
            />{' '}
            <span>Pagamento Único</span>
          </div>
          <div>
            <Switch
              id='toggle-payment-open'
              checked={product.payment.type === 'open'}
              onChange={() => setPaymentType('open')}
            />{' '}
            <span>Open</span>
          </div>
          <div>
            <Switch
              id='toggle-payment-free'
              checked={product.payment.type === 'free'}
              onChange={() => setPaymentType('free')}
            />{' '}
            <span>Free</span>
          </div>
          <div>
            <Switch
              id='toggle-payment-subscription'
              checked={product.payment.type === 'subscription'}
              onChange={() => setPaymentType('subscription')}
            />{' '}
            <span>Subscription</span>
          </div>
        </div>
      </div>

      <div className='bg-surface-default flex flex-row gap-2'>
        <FormGroup collapsable={collapsable} showValidationState={validationState} reviewMode={reviewMode}>
          <Blululup />
        </FormGroup>
        <div className='flex w-[600px] flex-col items-start gap-6 p-8' style={bgStyle}>
          <PreviewProduct />
          <div>
            <pre>{JSON.stringify(product, null, 2)}</pre>
          </div>
        </div>
      </div>
    </>
  );
}
